// extracted by mini-css-extract-plugin
export var symbol = "CurrencyFormatter-module--symbol--7WpyO";
export var price = "CurrencyFormatter-module--price--L5bT9";